<template>
  <div class="voz-banner-content">
    <div
      class="voz-banner-image"
      :style="{ backgroundImage: `url(${vozPageStoreBannerImageSrc})` }"
    ></div>
    <div class="voz-overlay-image">
      <h1 class="voz-banner-title">
        {{ vozPageStoreBannerImageTitle }}
      </h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VozPageMixin from "@/mixins/voz-page-mixin"
import { VozPageStore } from '@/store/verbal-identity-page/voz-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class VozBannerSection extends Mixins(VozPageMixin) {
  vozPageStore: PageStoreContract = getModule(VozPageStore, this.$store)

  get vozPageStoreBannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get vozPageStoreBannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getVozPageStore(): Promise<void> {
    await this.vozPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.vozPageStore.isLoading) {
      await this.getVozPageStore()
    }
  }
}
</script>

<style lang="scss">
.voz-banner-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;
  max-height: 28rem;
  width: 100%;
  justify-items: center;
  justify-content: center;
}

.voz-banner-image {
  position: relative;
  width: 100%;
  height: 451px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.voz-overlay-image {
  position: absolute;
  bottom: 9rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.voz-banner-title {
  font-size: 8rem;
  width: 1rem;
  margin: 0;
  font-weight: 400;
  letter-spacing: -0.01em;
  text-align: left;
}
</style>
